import React from 'react';


const SignedInMenuItems = [
  {
    key: 'upload-prints',
    title: 'Upload Photos',
    iconName: 'upload',
    clickHandler: () => window.location.href = '/order/prints-builder'
  },
  {
    key: 'photos',
    title: 'My Photos',
    iconName: 'photos',
    clickHandler: () => window.location.href = '/account/my-photos'
  },
  {
    key: 'upload-acct',
    title: 'My Projects',
    iconName: 'upload',
    clickHandler: () => window.location.href = '/account/projects'
  },
  {
    key: 'account',
    title: 'My Account',
    iconName: 'account',
    clickHandler: () => window.location.href = '/account'
  },
  {
    key: 'help',
    title: 'Help',
    iconName: 'help',
    clickHandler: () => window.location.href = '/about/help'
  },
  {
    key: 'keyboard',
    title: 'Keyboard Shortcuts',
    iconName: 'keyboard',
    clickHandler: () => window.showHotKeys()
  },
  {
    key: 'sign-out',
    title: 'Sign Out',
    iconName: 'sign-out',
    clickHandler: () => window.location.href = '/logout'
  }
];

const SignedInMenu = ({ storageProviderPresent }) => (
  SignedInMenuItems.map(({ key, title, iconName, clickHandler }) => (
    storageProviderPresent && (<button
      key={key}
      type='button'
      className='dropdown-item'
      onClick={clickHandler}
    >
      <i role='presentation' className={`skinny-icon ${iconName}`} />
      <span className='text-nowrap'>{title}</span>
    </button>)
  ))
);

export default SignedInMenu;
